'use client'
import { getDynamicLink } from '@/lib/util/get-router'
import dayjs from 'dayjs'
import { useRouter } from 'next/navigation'
import React from 'react'

export default function BlogCard({ item }: { item: any }) {
  const router = useRouter()
  return (
    <div
    onClick={() =>
      router.push(
        `${getDynamicLink()}/${item.id}?title=${item.cate.title}`
      )
    }
    className="flex gap-4 group cursor-pointer px-4 transition-shadow hover:shadow-[0_0_10px_0_rgba(0,0,0,0.2)]"
  >
    <div className="w-[140px] h-[80px] flex-shrink-0 overflow-hidden rounded-sm">
      <img
        src={item.cover}
        alt={item.title}
        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        referrerPolicy="no-referrer"
      />
    </div>
    <div className="flex flex-col justify-between py-1 flex-1">
      <h3 className="text-gray-800 text-[15px] group-hover:text-main transition-colors line-clamp-2 leading-snug">
        {item.title}
      </h3>
      <p className="text-gray-400 text-sm">{dayjs(+item.created_at * 1000).format('YYYY-MM-DD')}</p>

    </div>
  </div>
  )
}
